import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useSelectedLanguage from './useSelectedLanguage'

const useI18next = () => {
  const { i18n } = useTranslation()
  const { isTranslationsEnabled, selectedLanguage } = useSelectedLanguage()

  useEffect(() => {
    if (isTranslationsEnabled) {
      i18n.changeLanguage(selectedLanguage).catch((error) => {
        console.error('Failed to change language:', error)
      })
    }
  }, [selectedLanguage, i18n, isTranslationsEnabled])
}

export default useI18next
